module.exports = __webpack_public_path__ + "media/complaint.db3d3269.wav";